goog.provide("shadow.js.shim.module$$mui$material$OutlinedInput$default");
shadow.js.shim.module$$mui$material$OutlinedInput$default = shadow.js.shim.module$$mui$material$OutlinedInput.default;
